
// src/helpers/agent-type.js

export const isSmartPhone = false



// WEBPACK FOOTER //
// ./src/helpers/agent-type.js